module.exports = __webpack_public_path__ + "img/carlos.14bee9a1.jpeg";